export class SchedulerDialogViewModel
{
    opened: boolean = false;

    show()
    {

        this.opened = true;
    }

    close()
    {
        this.opened = false;
    }
}